// Mock data for Happy Rental Cancun

export const inflatables = [
  {
    id: 1,
    name: "Castillo Premium",
    category: "Castillos Inflables",
    description: "Castillo inflable de lujo perfecto para eventos grandes. Diseño colorido y seguro con capacidad para hasta 15 niños.",
    price: 1200,
    image: "/img/photo-1740033135773-bf7c886ae45a.jpeg",
    features: ["Capacidad 15 niños", "6m x 6m", "Instalación incluida", "Supervisión disponible"]
  },
  {
    id: 2,
    name: "Castillo Mágico",
    category: "Castillos Inflables",
    description: "Experiencia mágica para los más pequeños con diseño temático y colores vibrantes.",
    price: 1500,
    image: "/img/castillo.jpg",
    features: ["Capacidad 12 niños", "5m x 5m", "Temático", "Seguro y certificado"]
  },
  {
    id: 3,
    name: "Tobogán Gigante Acuático",
    category: "Toboganes Gigantes",
    description: "Tobogán gigante de agua para eventos espectaculares. Diversión garantizada para todas las edades.",
    price: 3500,
    image: "/img/gigante.jpg",
    features: ["Altura 8m", "Sistema de agua", "Capacidad alta", "Supervisión incluida"]
  },
  {
    id: 4,
    name: "Tobogán Extremo",
    category: "Toboganes Gigantes",
    description: "Tobogán de acción extrema para eventos inolvidables. Adrenalina pura.",
    price: 4200,
    image: "/img/mo.jpg",
    features: ["Altura 10m", "Doble carril", "Ultra seguro", "Experiencia premium"]
  },
  {
    id: 5,
    name: "Pista de Obstáculos Extrema",
    category: "Pistas de Obstáculos",
    description: "Pista de obstáculos de nivel profesional. Desafío perfecto para competencias y eventos corporativos.",
    price: 5000,
    image: "/img/obstaculos.jpg",
    features: ["15m de largo", "Obstáculos múltiples", "Competencias", "Setup profesional"]
  },
  {
    id: 6,
    name: "Zona de Juegos Premium",
    category: "Juegos Interactivos",
    description: "Área completa de juegos interactivos para eventos grandes. Diversión ilimitada.",
    price: 6000,
    image: "/img/aliens.jpg",
    features: ["Área completa", "Múltiples actividades", "Hasta 50 niños", "Personal incluido"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "María González",
    event: "Fiesta de 15 Años",
    rating: 5,
    comment: "Increíble servicio, los inflables son de primera calidad. Todos los invitados quedaron encantados.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100"
  },
  {
    id: 2,
    name: "Carlos Ruiz",
    event: "Evento Corporativo",
    rating: 5,
    comment: "Profesionalismo de primer nivel. Perfecto para nuestro evento empresarial con más de 200 personas.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100"
  },
  {
    id: 3,
    name: "Ana Martínez",
    event: "Cumpleaños Infantil",
    rating: 5,
    comment: "Los niños no querían irse. Inflables seguros, limpios y el equipo muy profesional.",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100"
  }
];

export const faqs = [
  {
    id: 1,
    question: "¿Qué incluye el servicio de renta?",
    answer: "Nuestro servicio incluye entrega, instalación profesional, supervisión durante el evento (opcional), y retiro al finalizar. Todo nuestro equipo está certificado y los inflables cumplen con normas de seguridad internacionales."
  },
  {
    id: 2,
    question: "¿Con cuánta anticipación debo reservar?",
    answer: "Recomendamos reservar con al menos 2 semanas de anticipación para eventos pequeños y 1 mes para eventos grandes. Sin embargo, contáctanos y haremos nuestro mejor esfuerzo por acomodar tu fecha."
  },
  {
    id: 3,
    question: "¿Qué espacio se necesita para la instalación?",
    answer: "El espacio varía según el inflable. Generalmente necesitamos un área plana de 2 metros adicionales alrededor del inflable. Nuestro equipo visitará tu locación sin costo para confirmar viabilidad."
  },
  {
    id: 4,
    question: "¿Los inflables son seguros?",
    answer: "Absolutamente. Todos nuestros inflables cuentan con certificaciones internacionales, están fabricados con materiales de primera calidad y son inspeccionados antes de cada evento. Incluimos personal capacitado para supervisión."
  },
  {
    id: 5,
    question: "¿Qué pasa si llueve el día del evento?",
    answer: "Ofrecemos flexibilidad total. Puedes reprogramar sin costo adicional hasta 48 horas antes del evento. Para eventos al aire libre, tenemos opciones de carpas y resguardo."
  }
];
